import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const AUTH_STATE = {
  IDLE: 'idle',
  AUTHENTICATING: 'authenticating',
  AUTHENTICATED: 'authenticated',
  LOGIN_SUCCESS: 'loginSuccess',
  TOKEN_AUTHENTICATED: 'tokenAuthenticated',
  INLINE: 'inline',
  LOGIN: 'login',
}

export const useAuthStore = defineStore('auth', () => {
  // State
  const authState = ref(AUTH_STATE.IDLE)
  const isPlaying = ref(false)
  const loginData = ref({
    provider: '',
    countryCode: null,
    phone: null,
    email: null,
    username: null,
    password: null,
    additionalUserInfo: null,
  })
  const fc = ref(null)
  const deviceTokenChecked = ref(false)

  // Getters
  const getAuthState = computed(() => authState.value)
  const getIsPlaying = computed(() => isPlaying.value)
  const getLoginData = computed(() => loginData.value)
  const getFc = computed(() => fc.value)
  const isAuthenticated = computed(() => authState.value === AUTH_STATE.AUTHENTICATED)
  const isAuthenticating = computed(() => authState.value === AUTH_STATE.AUTHENTICATING)

  // Actions
  const setAuthState = (state) => {
    authState.value = state
  }

  const setIsPlaying = (playing) => {
    isPlaying.value = playing
  }

  const setLoginData = (data) => {
    loginData.value = { ...loginData.value, ...data }
  }

  const resetLoginData = () => {
    loginData.value = {
      provider: '',
      countryCode: null,
      phone: null,
      email: null,
      username: null,
      password: null,
      additionalUserInfo: null,
    }
  }

  const setFc = (value) => {
    fc.value = value
  }

  return {
    // State
    authState,
    isPlaying,
    loginData,
    fc,
    deviceTokenChecked,
    // Getters
    getAuthState,
    getIsPlaying,
    getLoginData,
    getFc,
    isAuthenticated,
    isAuthenticating,
    // Actions
    setAuthState,
    setIsPlaying,
    setLoginData,
    resetLoginData,
    setFc,
  }
})
